import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel
} from '@mui/material';
import { PaginationDesktop, SkeletonDesktop, TargetStatus } from '../../../../../components';
import { goToDatailsContract } from '../../../../../router/coordinator';
import { Order } from '../../../../../utils/enums';
import { hasPermission } from '../../../../../utils';

export function DesktopTable({
  contracts,
  navigate,
  count,
  loading,
  page,
  offset,
  order,
  orderBy,
  handlePage,
  handleChangeRowsPerPage,
  handleOrder
}) {
  const goTo = (uuid) => {
    if (hasPermission('FIND_CONTRACT')) {
      goToDatailsContract(navigate, uuid);
    }
  };

  const contractsList = contracts?.map((c) => {
    return (
      <TableRow
        key={c.id}
        onClick={() => goTo(c.uuid)}
        className={!hasPermission('FIND_CONTRACT') && 'not-effect'}
      >
        <TableCell>{c.id && c.id}</TableCell>
        <TableCell>
          <TargetStatus status={c.status} />
        </TableCell>
        <TableCell>{c.segments?.title?.toTitleCase()}</TableCell>
        <TableCell>{c.provider?.name?.toTitleCase()}</TableCell>
        <TableCell>{c.initDate.toMask('date')}</TableCell>
        <TableCell>
          {c.additionalDate?.toMask('date') || c.expirationDate?.toMask('date')}
        </TableCell>
      </TableRow>
    );
  });

  function RenderTable() {
    if (loading) {
      return <SkeletonDesktop numbersOfColumns={6} />;
    }

    return contractsList;
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Segmento</TableCell>
              <TableCell>Fornecedor</TableCell>
              <TableCell>
                <TableSortLabel
                  direction={order}
                  active={order === Order.ASC && orderBy === 'initDate'}
                  onClick={() => handleOrder('initDate')}
                >
                  Data de início
                </TableSortLabel>
              </TableCell>
              <TableCell>Data de expiração vigente</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <RenderTable />
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationDesktop
        count={count}
        page={page}
        rowsPerPage={offset}
        handlePage={handlePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
}
